/* eslint-disable import-x/no-default-export */
import Chance from 'chance';
const chance = new Chance();

type SalaryType = 'Annual' | 'Monthly' | 'Hourly';
const seekSalaryTypes: SalaryType[] = ['Annual', 'Hourly'];
const jobsDbSalaryTypes: SalaryType[] = ['Monthly', 'Hourly'];

const countryCodeCountryNameMap = {
  AU: 'Australia',
  NZ: 'New Zealand',
  GB: 'The United Kingdom',
  HK: 'Hong Kong',
  TH: 'Thailand',
  ID: 'Indonesia',
} as const;

const countryCodeCurrencyCodeMap = {
  AU: 'AUD',
  NZ: 'NZD',
  GB: 'GBP',
  HK: 'HKD',
  ID: 'IDR',
  TH: 'THB',
} as const;

export default () => {
  const id = chance.guid();

  const countryCode = chance.pickone(
    Object.keys(countryCodeCountryNameMap),
  ) as keyof typeof countryCodeCountryNameMap;
  const name = countryCodeCountryNameMap[countryCode];

  const currencyCode = countryCodeCurrencyCodeMap[countryCode];

  const salaryType = ['AU', 'NZ', 'GB'].includes(countryCode)
    ? chance.pickone(seekSalaryTypes)
    : chance.pickone(jobsDbSalaryTypes);
  const amount = chance.bool() ? chance.integer({ min: 1, max: 999999 }) : null;

  const description = amount ? `${currencyCode} ${amount} ${salaryType}` : null;

  return {
    id,
    country: {
      countryCode,
      name,
    },
    currencyCode,
    description,
    salaryType,
    amount,
  };
};
